var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting 1",
    clipPath: "url(#clip0_8748_6539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.54472 6.39088C10.8991 5.03646 10.8991 2.8405 9.54472 1.48607C8.19029 0.131644 5.99433 0.131644 4.63991 1.48607C3.28548 2.8405 3.28548 5.03646 4.63991 6.39088C5.99433 7.74531 8.19029 7.74531 9.54472 6.39088Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7031 15.3684C19.5672 14.9278 20.721 13.0595 20.2804 11.1955C19.8398 9.33147 17.9715 8.17758 16.1075 8.6182C14.2435 9.05882 13.0896 10.9271 13.5302 12.7911C13.9709 14.6551 15.8391 15.809 17.7031 15.3684Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.89455 23.4309C9.75856 22.9903 10.9124 21.122 10.4718 19.258C10.0312 17.394 8.16293 16.2401 6.29892 16.6807C4.43491 17.1213 3.28102 18.9896 3.72164 20.8536C4.16226 22.7176 6.03053 23.8715 7.89455 23.4309Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99422 2.37695H2.02884C1.1708 2.37695 0.46875 3.079 0.46875 3.93705C0.46875 4.79509 1.1708 5.49714 2.02884 5.49714H3.99422C3.75769 5.02816 3.62447 4.49819 3.62447 3.93705C3.62447 3.37595 3.75769 2.84594 3.99422 2.37695Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1924 2.37695C10.429 2.84594 10.5622 3.37591 10.5622 3.93705C10.5622 4.49814 10.429 5.02816 10.1924 5.49714H21.9714C22.8294 5.49714 23.5315 4.79509 23.5315 3.93705C23.5315 3.07895 22.8294 2.37695 21.9714 2.37695H10.1924Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8078 10.4395H2.02884C1.1708 10.4395 0.46875 11.1415 0.46875 11.9995C0.46875 12.8576 1.1708 13.5596 2.02884 13.5596H13.8078C13.5712 13.0907 13.438 12.5607 13.438 11.9995C13.438 11.4385 13.5713 10.9084 13.8078 10.4395Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3757 11.9995C20.3757 12.5606 20.2424 13.0907 20.0059 13.5596H21.9712C22.8293 13.5596 23.5314 12.8576 23.5314 11.9995C23.5314 11.1415 22.8293 10.4395 21.9713 10.4395H20.0059C20.2424 10.9084 20.3757 11.4385 20.3757 11.9995Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9714 18.502H10.1924C10.429 18.9709 10.5622 19.5009 10.5622 20.062C10.5622 20.6231 10.429 21.1532 10.1924 21.6221H21.9714C22.8294 21.6221 23.5315 20.9201 23.5315 20.062C23.5315 19.204 22.8294 18.502 21.9714 18.502Z",
    fill: "#C1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62447 20.062C3.62447 19.501 3.75769 18.9709 3.99427 18.502H2.02884C1.1708 18.502 0.46875 19.204 0.46875 20.062C0.46875 20.9201 1.1708 21.6221 2.02884 21.6221H3.99422C3.75769 21.1532 3.62447 20.6231 3.62447 20.062Z",
    fill: "#C1DBFC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8748_6539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredSetting);
export default __webpack_public_path__ + "static/media/colored-setting.541985cf5d03527c99ba3bb444ffb91c.svg";
export { ForwardRef as ReactComponent };